import { useCallback } from 'react';
import { useFlagsService } from '@atlassian/jira-flags';
import { STATUS_TYPE } from '@atlassian/jira-platform-field-config/src/index.tsx';
import type { GroupContextField } from '../types.tsx';
import {
	getCreatedIssueFieldValue,
	getIssueCreateHiddenFlag,
	getIssueCreateSuccessFlag,
	getStatusName,
} from './utils.tsx';
import type { CreatedIssue } from './types.tsx';

export type ShouldSkipIssuesConnectionUpdate = (
	groupContextField?: GroupContextField,
	createdIssue?: CreatedIssue | null,
) => boolean;

export const useShouldSkipIssuesConnectionUpdate = (): ShouldSkipIssuesConnectionUpdate => {
	const { showFlag } = useFlagsService();

	return useCallback(
		(groupContextField?: GroupContextField, createdIssue?: CreatedIssue | null) => {
			if (!createdIssue) {
				return false;
			}
			const issueKey = createdIssue.key;

			if (createdIssue.matchesIssueSearch === false) {
				issueKey && showFlag(getIssueCreateHiddenFlag({ issueKey }));
				return true;
			}

			const hasGroupValueChanged =
				!!groupContextField &&
				getCreatedIssueFieldValue(createdIssue, groupContextField.fieldId) !==
					groupContextField.fieldValue;

			if (hasGroupValueChanged && groupContextField?.fieldType === STATUS_TYPE) {
				issueKey &&
					showFlag(
						getIssueCreateSuccessFlag({
							issueKey,
							statusName: getStatusName(createdIssue),
						}),
					);
			} else {
				issueKey && showFlag(getIssueCreateSuccessFlag({ issueKey }));
			}

			return hasGroupValueChanged;
		},
		[showFlag],
	);
};
